<template>
  <div class="drawer">
    <div class="side" :class="direction" :style="{ width: width }">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: "450px"
    },
    direction: {
      type: String,
      default: "right"
    }
  }
};
</script>

<style lang="stylus" scoped>
.side
  position fixed
  bottom 5px
  top 105px
  z-index 8

  @media (max-width 1366px)
    top 65px
@media (max-width 1280px)
  .side
    top 68px !important
.right
  right 5px

.left
  left 5px
</style>
